import { IColumn } from "./dataTable.common";
import React from "react";
import { SelectColumn } from "./dataTable.selectColumn";
import { safeextend } from "../helpers";

export interface GroupRowProps<T> {
  columns: IColumn<any, any>[];
  groupKey: string;
  groupLevel: number;
  column: IColumn<any, any>;
  styleSelector?: (item: T | null) => React.CSSProperties | undefined;
  elements: T[];
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  onRemoveGrouping(): void;
}

export class GroupRow<T> extends React.PureComponent<GroupRowProps<T>> {
  render() {

    let selectColumn: SelectColumn<T> | undefined;
    if (this.props.columns[0] instanceof SelectColumn)
      selectColumn = this.props.columns[0] as SelectColumn<T>;

    var span =
      selectColumn === undefined
        ? this.props.columns.length
        : this.props.columns.length - 1;

    var firstTd: React.ReactElement<any> | undefined;
    if (selectColumn) {
      firstTd = <td>{selectColumn.getHeader(this.props.elements)}</td>;
    }

    let bgColor = this.props.groupLevel === 0 ? "#fcf7df" : "#e4f2de";
    if (this.props.isCollapsed) bgColor = "#e7eaec";

    const style = safeextend(
      { backgroundColor: bgColor },
      this.props.styleSelector && this.props.styleSelector(null)
    );
    return (
      <tr style={style} className="group-row">
        {firstTd}
        <td colSpan={span}>
          <span style={{ marginLeft: this.props.groupLevel * 10 }}>
            <a onClick={this.props.onToggleCollapse}>
              <i
                className={
                  "d-print-none fa-lg " +
                  (this.props.isCollapsed ? "far fa-plus-square" : "far fa-minus-square")
                }
                style={{ marginRight: 10 }}
              />
            </a>{" "}
            <strong>{this.props.column.getGroupTemplate(this.props.groupKey)}</strong>{" "}
            <a onClick={this.props.onRemoveGrouping}>
              <i
                title="Elimina Raggruppamento"
                className="fa fa-times d-print-none"
                style={{ marginRight: 5 }}
              />
            </a>
          </span>
          <span className="float-end">
            <i
              style={{
                display: this.props.elements.length > 0 ? "" : "none",
                marginRight: 5
              }}
              className="fa fa-bars"
            />{" "}
            {"Tot Elementi: " + this.props.elements.length}
          </span>
        </td>
      </tr>
    );
  }
}
